export default "__VITE_ASSET__neHZrpI2__"